(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('suggestionAddon', ['Suggestions', 'Principal', 'Connexion', suggestionAddon]);

    function suggestionAddon(Suggestions, Principal, Connexion) {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/addon/suggestion/suggestion-addon.html',
            controller: 'SuggestionAddonController',
            controllerAs: 'vd'
        };
        return directive;
    }
})();
